import React from 'react';
import { painPoints } from '../data/landing';
export function PainSection() {
  return <section className="bg-parchment py-20 md:py-28" data-id="element-92" data-mp="38xoher0tacsw">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-93" data-mp="38x5ccaw9fiwa">
        <h2 className="font-serif text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-94" data-mp="2uyxappoa3tes">
          ¿Sentís que necesitás acercarte más a Dios, pero no sabés por dónde empezar?
        </h2>
        <div className="mx-auto mt-8 max-w-2xl space-y-5 text-lg leading-relaxed text-ink/80" data-id="element-95" data-mp="2l82je6w6e3mh">
          <p data-id="element-96" data-mp="2pzc917hq56yd">Hay momentos en los que necesitamos detenernos, hacer silencio y volver a escuchar la Palabra.</p>
          <p data-id="element-97" data-mp="2bb7orz30wndh">
            A veces leemos un Salmo, pero nos cuesta comprender todo lo que nos quiere transmitir. Otras veces, queremos
            dedicar más tiempo a nuestra fe, pero terminamos postergándolo entre las obligaciones de todos los días.
          </p>
          <p data-id="element-98" data-mp="278bc0p05zlhg">
            Y cuando atravesamos momentos de incertidumbre, preocupación o tristeza, encontrar palabras que nos ayuden a
            reflexionar puede convertirse en algo profundamente valioso.
          </p>
        </div>
        <p className="mx-auto mt-10 max-w-2xl font-serif text-2xl italic leading-snug text-gold-dark md:text-3xl" data-id="element-99" data-mp="3nkdzhc7zyv6a">
          Tu relación con Dios también necesita tiempo, atención y un corazón dispuesto a escuchar.
        </p>
      </div>

      <div className="mx-auto mt-20 max-w-5xl px-5 md:px-8" data-id="element-100" data-mp="emwqmzar42o">
        <h3 className="text-center font-serif text-3xl font-semibold text-ink md:text-4xl" data-id="element-101" data-mp="38xkogj5igbjw">
          ¿Te identificás con alguna de estas situaciones?
        </h3>
        <ul className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-2" data-id="element-102" data-mp="3im2ouz9vogn0">
          {painPoints.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-5 bg-cream p-7 md:p-9" data-id="element-103" data-mp="2q5rzcztkbahg">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold-light" data-id="element-104" data-mp="2q3oyfkqvfwxy">
                <Icon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-105" data-mp="p3trpjzs6p3k" />
              </span>
              <div data-id="element-106" data-mp="u2x09eeyzdga">
                <h4 className="font-serif text-2xl font-semibold leading-tight text-ink" data-id="element-107" data-mp="u2detnq426xi">{title}</h4>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-108" data-mp="yt3o3c1nqtxh">{text}</p>
              </div>
            </li>)}
        </ul>
        <p className="mx-auto mt-12 max-w-2xl text-center text-lg leading-relaxed text-ink/80" data-id="element-109" data-mp="12u5q20mylk35">
          <strong className="text-ink" data-id="element-110" data-mp="65zndj9ll1ri">No necesitás saberlo todo para empezar.</strong> A veces, el primer paso es
          simplemente abrir la Palabra y dedicarle unos minutos de tu día.
        </p>
      </div>
    </section>;
}